import { render, staticRenderFns } from "./ProdutoTab.vue?vue&type=template&id=3740d6b9"
import script from "./ProdutoTab.vue?vue&type=script&lang=js"
export * from "./ProdutoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports